import * as React from "react";
import Button from "@edaz/edazkit/Button";
import { IconType } from "@edaz/edazkit/Icon";
import { Col, Row } from "react-bootstrap";

type StepsNavigationButtonsProps = {
  tg: (value: string) => string;
  onBack?: () => void;
  continueDisabled?: boolean;
  onContinue: () => void;
};

export const StepsNavigationButtons = ({ tg, onBack, continueDisabled, onContinue }: StepsNavigationButtonsProps) => {
  return (
    <Row className="justify-content-center pt-4 pt-lg-7 pt-xl-7">
      {onBack ? (
        <>
          {/* Back button visible only in mobile view */}
          <Col lg={10} xl={4} className="p-2 w-auto d-md-none">
            <Button
              type="button"
              variant="light"
              className="px-lg-4 btn-block w-auto w-lg-100"
              onClick={onBack}
              iconLeft={IconType.ArrowLeft}></Button>
          </Col>
          {/* Back button visible only in tablet/desktop view */}
          <Col md={5} xl={4} className="p-2 d-none d-md-block">
            <Button type="button" variant="light" className="px-lg-4 btn-block" onClick={onBack} iconLeft={IconType.ArrowLeft}>
              {tg("back")}
            </Button>
          </Col>
        </>
      ) : undefined}
      {/* Continue button */}
      <Col md={5} xl={4} className="p-2 w-auto flex-grow-1">
        <Button
          type="button"
          variant="primary"
          className="px-2 px-md-4 btn-block"
          onClick={onContinue}
          disabled={continueDisabled}
          iconRight={IconType.ArrowRight}>
          {tg("continue")}
        </Button>
      </Col>
    </Row>
  );
};
